import { FaFacebook, FaTelegramPlane, FaRobot } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer
      className="fixed bottom-0 inset-x-0 w-full bg-gray-100 py-2 sm:py-1 text-gray-600"
      role="contentinfo"
      aria-label="Footer"
    >
      <div className="container mx-auto px-3 sm:px-4">
        <div className="flex justify-between items-center">
          {/* Mobile layout */}
          <div className="w-full flex justify-between items-center sm:hidden">
            <nav aria-label="Footer Navigation" className="flex-grow">
              <ul className="flex flex-wrap items-center gap-2 text-sm">
                <li>
                  <Link
                    to="/guide"
                    className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded py-1"
                  >
                    מדריכים
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms"
                    className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded py-1"
                  >
                    תנאי שימוש
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded py-1"
                  >
                    אודות
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded py-1"
                  >
                    צור קשר
                  </Link>
                </li>
                <li>
                  {/* /search is owned by the Cloudflare Worker (wrangler.toml route
                      "www.botimza.com/search*"), not an SPA route - a router <Link>
                      would try to client-side-match "/search" against App.jsx (only
                      "/search/:slug" exists there) and 404. Plain <a> forces a real
                      navigation through the Worker, same reasoning as PopularSearches.jsx. */}
                  <a
                    href="/search"
                    className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded py-1"
                  >
                    כל החיפושים
                  </a>
                </li>
              </ul>
            </nav>

            <div className="text-sm ml-2" aria-label="Social Media Links">
              <ul className="flex items-center gap-1">
                <li>
                  <a
                    href="https://www.facebook.com/groups/3175949432574851"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-1.5 inline-flex items-center"
                    aria-label="קבוצת פייסבוק Botimza"
                  >
                    <FaFacebook className="text-base" aria-hidden="true" />
                    <span className="sr-only">קבוצת פייסבוק Botimza</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/CoffeeBuyILBot"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-1.5 inline-flex items-center"
                    aria-label="בוט טלגרם CoffeeBuy"
                  >
                    <FaRobot className="text-base" aria-hidden="true" />
                    <span className="sr-only">בוט טלגרם CoffeeBuy</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/CoffeeBuyIL"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-1.5 inline-flex items-center"
                    aria-label="ערוץ טלגרם CoffeeBuy"
                  >
                    <FaTelegramPlane className="text-base" aria-hidden="true" />
                    <span className="sr-only">ערוץ טלגרם CoffeeBuy</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Desktop layout */}
          <nav aria-label="Footer Navigation" className="hidden sm:block">
            <ul className="flex flex-wrap items-center gap-4 text-sm">
              <li>
                <Link
                  to="/guide"
                  className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
                >
                  מדריכים
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
                >
                  תנאי שימוש
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
                >
                  אודות
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
                >
                  צור קשר
                </Link>
              </li>
              <li>
                {/* Plain <a>, not <Link> - see the mobile nav's comment above. */}
                <a
                  href="/search"
                  className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
                >
                  כל החיפושים
                </a>
              </li>
            </ul>
          </nav>

          {/* Desktop social links */}
          <div className="hidden sm:block text-sm" aria-label="Social Media Links">
            <ul className="flex items-center gap-2">
              <li>
                <a
                  href="https://www.facebook.com/groups/coffeeBuy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-2 inline-flex items-center"
                  aria-label="קבוצת פייסבוק CoffeeBuy"
                >
                  <FaFacebook className="text-xl" aria-hidden="true" />
                  <span className="sr-only">קבוצת פייסבוק CoffeeBuy</span>
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/CoffeeBuyILBot"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-2 inline-flex items-center"
                  aria-label="בוט טלגרם CoffeeBuy"
                >
                  <FaRobot className="text-xl" aria-hidden="true" />
                  <span className="sr-only">בוט טלגרם CoffeeBuy</span>
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/CoffeeBuyIL"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="!text-gray-700 hover:!text-blue-400 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-2 inline-flex items-center"
                  aria-label="ערוץ טלגרם CoffeeBuy"
                >
                  <FaTelegramPlane className="text-xl" aria-hidden="true" />
                  <span className="sr-only">ערוץ טלגרם CoffeeBuy</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
